import { useLandingContent } from "@/lib/landing/LandingContentProvider";
import { phoneHref } from "@/lib/landing/resolve";
export default function LandingFooter({ onCall }: { onCall: () => void }) {
  const year = new Date().getFullYear();
  const { content } = useLandingContent();
  return (
    <footer className="landing-band-dark border-t border-landing-border py-7 text-[13.5px] text-landing-on-dark-muted">
      <div className="landing-container flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
        <p>
          © {year} Smartly Technologies, LLC · 333 H St Suite 5000, Chula
          Vista, CA 91910 ·{" "}
          <a
            href={phoneHref(content.phone)}
            onClick={onCall}
            className="text-landing-answer underline"
          >
            {content.phone}
          </a>
        </p>
        <nav aria-label="Legal" className="flex flex-wrap gap-x-[22px] gap-y-3">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="/privacy-policy"
            className="text-landing-answer underline"
          >
            Privacy Policy
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="/terms-of-service"
            className="text-landing-answer underline"
          >
            Terms of Service
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="/your-privacy-choices"
            className="text-landing-answer underline"
          >
            Your Privacy Choices
          </a>
        </nav>
      </div>
    </footer>
  );
}
